import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const estadoEntradaBrasilService = {

    getAllAtivos: () => {
        return api.get(`${OperacoesWebAPI.EstadoEntradaBrasil}/getallativos`)
            .then((res) => res)
            .catch(err => err)
    },

    post: (escolaridade: any) => {

        return api.post(`${OperacoesWebAPI.EstadoEntradaBrasil}`, escolaridade)
    },

    put: (escolaridade: any) => {
        return api.put(`${OperacoesWebAPI.EstadoEntradaBrasil}`, escolaridade)
    },

    delete: (escolaridadeID: number) => {
        return api.delete(`${OperacoesWebAPI.EstadoEntradaBrasil}?id=${escolaridadeID}`)
    }
}